export default __webpack_public_path__ + "static/media/DocksMap.a1575ecd.jpg";